import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Result } from '@hereisyourgitanton/core';
import { IUserService } from '../interfaces/user-service';
import { UsersApi } from '@tradgine/data-access/auth';
import { User } from '../interfaces/user';

@Injectable()
export class UserService implements IUserService {
    private readonly api: UsersApi = inject(UsersApi);

    getUsers(): Observable<Result<User[], Error>> {
        throw new Error('Method not implemented.');
    }
}
